<script setup>
import { ref, watch} from 'vue'
import { useRouter } from 'vue-router'
import { event } from 'vue-gtag'

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	type: {
		type: String,
		required: true,
	},
	msgContent: {
		type: String,
		required: true
	},
	btnLabel: {
		type: String,
		required: false,
		default: ''
	}	
})		

//reactive field proxies
const showBanner = ref(props.show)
const typeClass = ref(props.type)

//local variables
const router = useRouter()

//methods
function hideBanner() {
	showBanner.value = false
}

function showUpdates() {
	router.push({ name: 'AboutView' })
}

watch(
	() => props.show,
		(val) => {
		showBanner.value = val;
		if(props.type == 'error') {
			event('error_warning', { 'message' : props.msgContent.replace(/[^a-zA-Z0-9 ]/g, "") })
		}
	}
);

watch(
	() => props.type,
		(val) => {
		typeClass.value = val;
	}
);
</script>

<template>
	<div v-if="showBanner" class="banner-container"  :class="typeClass">
		<div class="banner-content">
			<span v-if="props.type == 'info'" :class="typeClass">
				<i class="fa-solid fa-circle-info"></i>
			</span>			
			<span v-else-if="props.type == 'success'" :class="typeClass">
				<i class="fa-solid fa-circle-check"></i>
			</span>
			<span v-else-if="props.type == 'warning'" :class="typeClass">
				<i class="fa-solid fa-triangle-exclamation"></i>
			</span>
			<span v-else-if="props.type == 'error'" :class="typeClass">
				<i class="fa-solid fa-circle-exclamation"></i>
			</span>
			<!-- else info message -->
			<span v-else class="info">
				<i class="fa-solid fa-circle-info"></i>
			</span>												
			<span v-html="props.msgContent"></span>
		</div>
		<div class="banner-controls">
			<div class="banner-action">
				<div v-if="props.btnLabel != ''">
					<button class='btn-tertiary' @click="showUpdates">{{props.btnLabel}}</button>
				</div>
			</div>
			<div class="banner-hide">
				<button class="btn-icon btn-close" :class="typeClass" @click="hideBanner"><i class="fa-solid fa-times"></i></button>
			</div>	
		</div>
	</div>
</template>
   
<style scoped>
	.banner-container {
		width: 100%;
		min-height: 3.5rem;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		align-items:start;
		padding: 1.2rem;
		border-radius: var(--radius-lg, .5rem);
		border: 1.5px solid var(--border-color-DividerActive, #064291); 
	}

	.banner-content {
		font-size: var(--font-size-Base);
		font-family: var(--font-family-Title);
		color: var(--brand-color-MedGrey);
		display: flex;
	}
	.banner-content :deep(span a[href^="mailto:"]) {
		color: var(--text-Link);
	}

	.banner-controls {
		display: flex;
	}

	.banner-hide {
		margin-left: .2rem;
	}

	.btn-tertiary {
		padding: 0;
    	margin-right: 1.25rem;
		height: unset;
		min-height: unset;
	}

	.btn-close {
		color: var(--icon-cta-Blue, #064291);
		text-align: right;
		font-weight: 900;
		font-size: var(--font-size-H5);
		min-width: 1rem;
		min-height: 1rem;
		height: unset;
		line-height: 1.25rem;
	}

	/* info */
	.banner-container.info {
		border: 1.5px solid var(--brand-color-IndicatorsBlue); 
	}

	.banner-container.info.side {
		min-height: unset;
		padding: .5rem;
	}	

	.banner-content .info {
		color: var(--brand-color-IndicatorsBlue); 
		padding-right: .5rem;
	}

	.btn-close.info {
		color: var(--brand-color-IndicatorsBlue); 
	}

	/* success */
	.banner-container.success {
		border: 1.5px solid var(--brand-color-Green);
	}

	.banner-content .success {
		color: var(--brand-color-Green);
		padding-right: .75rem;
	}

	.btn-close.success {
		color: var(--brand-color-Green); 
	}

	/* warning */
	.banner-container.warning {
		border: 1.5px solid var(--brand-color-BurntYellow);
	}

	.banner-content .warning {
		color: var(--brand-color-BurntYellow);
		padding-right: .75rem;
	}

	.btn-close.warning {
		color: var(--brand-color-BurntYellow); 
	}	

	/* error */
	.banner-container.error {
		border: 1.5px solid var(--brand-color-Red); 
	}

	.banner-content .error {
		color: var(--brand-color-Red); 
		padding-right: .75rem;
	}

	.btn-close.error {
		color: var(--brand-color-Red); 
	}

</style>